import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FixturesDateHeader } from 'widgets/fixtures/js/components/fixtures-list/FixturesDateHeader';
import { TeamLineupsItem } from './TeamLineupsItem';

const DIGIT_ONLY_REGEX = /^[0-9]*$/;

export const TeamLineupsItemWrapper = ({ item }) => {
    const itemType = useMemo(() => {
        if (typeof item === 'string') {
            if (item.match(DIGIT_ONLY_REGEX) || item === 'TBCPC') {
                return 'date';
            }
            return 'round';
        }
        if (
            typeof item === 'object' &&
            'isBye' in item &&
            item.isBye === true
        ) {
            return 'bye';
        }

        return 'match';
    }, [item]);

    const match = item.rosterItem
        ? {
              ...item.rosterItem,
              matchId: item.id,
              compSeasonPid: item.compSeason?.providerId
          }
        : null;

    const status = match?.match?.status || null;

    const hasMilestones =
        match?.matchRoster?.homeTeam.milestones.length > 0 ||
        match?.matchRoster?.awayTeam.milestones.length > 0;

    switch (itemType) {
        case 'date':
            return <FixturesDateHeader dateKey={item} />;
        case 'match':
            return (
                match &&
                match.match && (
                    <TeamLineupsItem
                        match={match}
                        hasMilestones={hasMilestones}
                        status={status}
                    />
                )
            );
        default:
            return <></>;
    }
};

TeamLineupsItemWrapper.propTypes = {
    item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
